// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.hidden {
  display: none;
}
.resize {
  resize: both;
}

:root {
    color-scheme: dark;
    --background: #212121;
    --surface: #2f2f2f;
    --surface-hover: #3a3a3a;
    --sidebar: #171717;
    --border: #3f3f3f;
    --text: #ececec;
    --muted: #a7a7a7;
    --accent: #b89954;
}

* { box-sizing: border-box; }

html, body, #root {
    width: 100%;
    height: 100%;
    margin: 0;
}

body {
    overflow: hidden;
    background: var(--background);
    color: var(--text);
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    -webkit-font-smoothing: antialiased;
}

button, textarea { font: inherit; }

.app {
    display: flex;
    width: 100%;
    height: 100dvh;
    background: var(--background);
}

.sidebar {
    width: 270px;
    flex: 0 0 270px;
    display: flex;
    flex-direction: column;
    padding: 12px;
    background: var(--sidebar);
    border-right: 1px solid #242424;
}

.sidebar-top { display: flex; flex-direction: column; gap: 14px; }

.logo-container {
    display: flex;
    align-items: center;
    min-height: 58px;
    padding: 8px 10px 14px;
    border-bottom: 1px solid #2c2c2c;
}

.logo { width: 132px; height: auto; object-fit: contain; }

.new-chat {
    width: 100%;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 10px 12px;
    margin: 0;
    color: var(--text);
    background: transparent;
    border: 1px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    transition: background 160ms ease, border-color 160ms ease;
}

.new-chat:hover { background: #242424; border-color: #303030; }
.new-chat svg { width: 18px; height: 18px; }

.sidebar-copy {
    margin-top: 22px;
    padding: 0 12px;
    color: #858585;
    font-size: 12px;
    line-height: 1.5;
}

.sidebar-copy-label {
    color: #b7b7b7;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .08em;
    text-transform: uppercase;
}

.sidebar-copy p { margin: 8px 0 0; }

.user-card {
    display: flex;
    align-items: center;
    gap: 11px;
    min-width: 0;
    margin-top: auto;
    padding: 12px 8px 4px;
    border-top: 1px solid #2c2c2c;
}

.user-avatar {
    position: relative;
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    display: grid;
    place-items: center;
    overflow: visible;
    border-radius: 50%;
    background: #5d5035;
    color: white;
    font-weight: 600;
}

.user-avatar img { width: 100%; height: 100%; border-radius: inherit; object-fit: cover; }

.status {
    position: absolute;
    right: -1px;
    bottom: 0;
    width: 10px;
    height: 10px;
    border: 2px solid var(--sidebar);
    border-radius: 50%;
    background: #777;
}

.status.Available, .status.AvailableIdle { background: #56a968; }
.status.Busy, .status.DoNotDisturb { background: #d45c58; }
.status.Away, .status.BeRightBack { background: #d69b46; }

.user-info { min-width: 0; }
.user-name { overflow: hidden; color: #ededed; font-size: 13px; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }
.user-email { margin-top: 2px; overflow: hidden; color: #858585; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }

.chat-container {
    position: relative;
    min-width: 0;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    height: 100dvh;
    margin: 0;
    background: var(--background);
}

.mobile-header { display: none; }

.welcome {
    width: min(760px, calc(100% - 40px));
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding: 32px 0 18px;
    text-align: center;
}

.welcome-icon, .assistant-avatar {
    display: grid;
    place-items: center;
    overflow: hidden;
    border: 1px solid #4a4231;
    border-radius: 50%;
    background: #292620;
}

.welcome-icon { width: 54px; height: 54px; margin-bottom: 20px; }
.welcome-icon img, .assistant-avatar img { width: 72%; height: 72%; object-fit: contain; }

.welcome h1 {
    margin: 0;
    color: #f2f2f2;
    font-size: clamp(25px, 3vw, 34px);
    font-weight: 600;
    letter-spacing: -.03em;
}

.welcome > p { max-width: 560px; margin: 12px 0 30px; color: var(--muted); font-size: 14px; line-height: 1.6; }

.suggestions {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.suggestions button {
    min-height: 116px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
    padding: 16px;
    margin: 0;
    color: #d8d8d8;
    background: transparent;
    border: 1px solid var(--border);
    border-radius: 14px;
    text-align: left;
    cursor: pointer;
    transition: background 160ms ease, border-color 160ms ease;
}

.suggestions button:hover:not(:disabled) { background: #292929; border-color: #555; }
.suggestions button:disabled { cursor: wait; opacity: .45; }
.suggestions svg { width: 19px; height: 19px; color: var(--accent); }
.suggestions span { font-size: 13px; line-height: 1.45; }

.messages {
    flex: 1 1;
    overflow-y: auto;
    scroll-behavior: smooth;
}

.messages-inner { width: min(820px, calc(100% - 40px)); margin: 0 auto; padding: 42px 0 28px; }

.message-row {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin-bottom: 28px;
}

.message-row.user { justify-content: flex-end; }
.assistant-avatar { width: 30px; height: 30px; flex: 0 0 30px; margin-top: 3px; }
.msg { min-width: 0; color: var(--text); font-size: 15px; line-height: 1.7; }
.msg.bot { width: calc(100% - 44px); }
.msg.user { width: fit-content; max-width: min(72%, 620px); }

.message-bubble { overflow-wrap: anywhere; }
.msg.user .message-bubble { padding: 10px 16px; background: var(--surface); border-radius: 20px; }
.message-bubble p:first-child { margin-top: 0 !important; }
.message-bubble p:last-child { margin-bottom: 0 !important; }
.message-bubble ul, .message-bubble ol { margin: 10px 0; padding-left: 22px; }
.message-bubble a { color: #7db4f4; text-decoration: underline; text-underline-offset: 2px; }

.code-block {
    max-width: 100%;
    margin: 14px 0;
    padding: 15px;
    overflow-x: auto;
    background: #141414;
    border: 1px solid #353535;
    border-radius: 10px;
}

.inline-code { padding: 2px 5px; color: #e5c981; background: #151515; border-radius: 4px; }

.input-area {
    flex: 0 0 auto;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 10px 24px 12px;
    background: linear-gradient(180deg, rgba(33,33,33,0), var(--background) 24%);
}

.composer-wrap { width: min(820px, 100%); }

.input-box {
    width: 100%;
    padding: 8px;
    background: var(--surface);
    border: 1px solid #494949;
    border-radius: 24px;
    box-shadow: 0 6px 28px rgba(0,0,0,.2);
    transition: border-color 160ms ease, box-shadow 160ms ease;
}

.input-box:focus-within { border-color: #656565; box-shadow: 0 8px 32px rgba(0,0,0,.26); }
.composer-row { display: flex; align-items: flex-end; gap: 6px; }

.input-box textarea {
    min-height: 36px;
    max-height: 180px;
    flex: 1 1;
    padding: 7px 6px 5px;
    overflow-y: auto !important;
    resize: none;
    outline: none;
    color: var(--text);
    background: transparent;
    border: 0;
    font-size: 15px;
    line-height: 1.5;
}

.input-box textarea::placeholder { color: #9a9a9a; }

.icon-button {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    display: grid;
    place-items: center;
    padding: 0;
    margin: 0;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
}

.attach-button { color: #cacaca; background: transparent; }
.attach-button:hover:not(:disabled) { background: #414141; }
.send-button { color: #202020; background: #f1f1f1; }
.send-button:hover:not(:disabled) { background: white; }
.icon-button:disabled { cursor: default; opacity: .32; }
.icon-button svg { width: 18px; height: 18px; }

.attachment-preview { position: relative; width: fit-content; margin: 2px 4px 8px; }
.attachment-preview > img { width: 84px; height: 68px; display: block; object-fit: cover; border-radius: 10px; }
.attachment-file { max-width: 230px; display: flex; align-items: center; gap: 8px; padding: 10px 12px; color: #ddd; background: #232323; border-radius: 10px; font-size: 12px; }
.attachment-file span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.remove-attachment { position: absolute; top: -7px; right: -7px; width: 22px; height: 22px; display: grid; place-items: center; padding: 0; margin: 0; color: #eee; background: #444; border: 2px solid var(--surface); border-radius: 50%; cursor: pointer; }

.input-disclaimer { margin: 7px 0 0; color: #8b8b8b; font-size: 11px; text-align: center; }
.connection-error { width: min(820px, calc(100% - 48px)); margin: 0 auto 2px; padding: 9px 12px; color: #ffc8c5; background: #4a2828; border-radius: 9px; font-size: 12px; text-align: center; }

.button-spinner { width: 15px; height: 15px; border: 2px solid #777; border-top-color: #222; border-radius: 50%; animation: spin .7s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

.messages::-webkit-scrollbar, .input-box textarea::-webkit-scrollbar { width: 7px; }
.messages::-webkit-scrollbar-thumb, .input-box textarea::-webkit-scrollbar-thumb { background: #4b4b4b; border-radius: 10px; }

@media (max-width: 760px) {
    .sidebar { display: none; }
    .mobile-header {
        min-height: 52px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 14px;
        margin: 0;
        border-bottom: 1px solid #303030;
        font-size: 14px;
    }
    .mobile-header button { width: 36px; height: 36px; display: grid; place-items: center; padding: 0; color: var(--text); background: transparent; border: 0; border-radius: 8px; }
    .welcome { width: calc(100% - 28px); padding-top: 20px; }
    .welcome-icon { width: 46px; height: 46px; margin-bottom: 15px; }
    .welcome > p { margin-bottom: 22px; }
    .suggestions { grid-template-columns: 1fr; gap: 8px; }
    .suggestions button { min-height: auto; flex-direction: row; align-items: center; justify-content: flex-start; gap: 12px; padding: 13px 14px; }
    .messages-inner { width: calc(100% - 28px); padding-top: 24px; }
    .message-row { gap: 10px; margin-bottom: 22px; }
    .msg.user { max-width: 85%; }
    .input-area { padding: 8px 10px 9px; }
    .input-disclaimer { display: none; }
    .input-box { border-radius: 20px; }
}

@media (max-height: 700px) and (min-width: 761px) {
    .welcome { justify-content: flex-end; }
    .welcome-icon { display: none; }
    .welcome > p { margin-bottom: 18px; }
    .suggestions button { min-height: 94px; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/chat.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;IACI,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,uGAAuG;IACvG,mCAAmC;AACvC;;AAEA,mBAAmB,aAAa,EAAE;;AAElC;IACI,aAAa;IACb,WAAW;IACX,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEjE;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA,QAAQ,YAAY,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAEzD;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,0DAA0D;AAC9D;;AAEA,kBAAkB,mBAAmB,EAAE,qBAAqB,EAAE;AAC9D,gBAAgB,WAAW,EAAE,YAAY,EAAE;;AAE3C;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA,kBAAkB,eAAe,EAAE;;AAEnC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,mBAAmB,WAAW,EAAE,YAAY,EAAE,sBAAsB,EAAE,iBAAiB,EAAE;;AAEzF;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,2CAA2C,mBAAmB,EAAE;AAChE,qCAAqC,mBAAmB,EAAE;AAC1D,oCAAoC,mBAAmB,EAAE;;AAEzD,aAAa,YAAY,EAAE;AAC3B,aAAa,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAChI,cAAc,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEhI;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,SAAS;IACT,6BAA6B;AACjC;;AAEA,iBAAiB,aAAa,EAAE;;AAEhC;IACI,oCAAoC;IACpC,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,gBAAgB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAChE,2CAA2C,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAEzF;IACI,SAAS;IACT,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,eAAe,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE9G;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,0DAA0D;AAC9D;;AAEA,2CAA2C,mBAAmB,EAAE,kBAAkB,EAAE;AACpF,+BAA+B,YAAY,EAAE,YAAY,EAAE;AAC3D,mBAAmB,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE;AACpE,oBAAoB,eAAe,EAAE,iBAAiB,EAAE;;AAExD;IACI,SAAO;IACP,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,kBAAkB,oCAAoC,EAAE,cAAc,EAAE,oBAAoB,EAAE;;AAE9F;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA,oBAAoB,yBAAyB,EAAE;AAC/C,oBAAoB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE;AAChF,OAAO,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5E,WAAW,wBAAwB,EAAE;AACrC,YAAY,kBAAkB,EAAE,0BAA0B,EAAE;;AAE5D,kBAAkB,uBAAuB,EAAE;AAC3C,4BAA4B,kBAAkB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AACjG,gCAAgC,wBAAwB,EAAE;AAC1D,+BAA+B,2BAA2B,EAAE;AAC5D,yCAAyC,cAAc,EAAE,kBAAkB,EAAE;AAC7E,oBAAoB,cAAc,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;;AAE5F;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,eAAe,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAE1F;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,4EAA4E;AAChF;;AAEA,iBAAiB,uBAAuB,EAAE;;AAE1C;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,qCAAqC;IACrC,0DAA0D;AAC9D;;AAEA,0BAA0B,qBAAqB,EAAE,sCAAsC,EAAE;AACzF,gBAAgB,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE;;AAEhE;IACI,gBAAgB;IAChB,iBAAiB;IACjB,SAAO;IACP,oBAAoB;IACpB,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA,mCAAmC,cAAc,EAAE;;AAEnD;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;;AAEA,iBAAiB,cAAc,EAAE,uBAAuB,EAAE;AAC1D,sCAAsC,mBAAmB,EAAE;AAC3D,eAAe,cAAc,EAAE,mBAAmB,EAAE;AACpD,oCAAoC,iBAAiB,EAAE;AACvD,wBAAwB,eAAe,EAAE,YAAY,EAAE;AACvD,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C,sBAAsB,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACnF,4BAA4B,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAC/G,mBAAmB,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,WAAW,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC/K,wBAAwB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACxF,qBAAqB,kBAAkB,EAAE,SAAS,EAAE,WAAW,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,UAAU,EAAE,SAAS,EAAE,WAAW,EAAE,gBAAgB,EAAE,gCAAgC,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAE7P,oBAAoB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC1F,oBAAoB,oCAAoC,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAE/L,kBAAkB,WAAW,EAAE,YAAY,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,mCAAmC,EAAE;AACtJ,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,uEAAuE,UAAU,EAAE;AACnF,mFAAmF,mBAAmB,EAAE,mBAAmB,EAAE;;AAE7H;IACI,WAAW,aAAa,EAAE;IAC1B;QACI,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,eAAe;QACf,SAAS;QACT,gCAAgC;QAChC,eAAe;IACnB;IACA,wBAAwB,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,UAAU,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,SAAS,EAAE,kBAAkB,EAAE;IAC/K,WAAW,wBAAwB,EAAE,iBAAiB,EAAE;IACxD,gBAAgB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;IAChE,eAAe,mBAAmB,EAAE;IACpC,eAAe,0BAA0B,EAAE,QAAQ,EAAE;IACrD,sBAAsB,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,2BAA2B,EAAE,SAAS,EAAE,kBAAkB,EAAE;IAC9I,kBAAkB,wBAAwB,EAAE,iBAAiB,EAAE;IAC/D,eAAe,SAAS,EAAE,mBAAmB,EAAE;IAC/C,YAAY,cAAc,EAAE;IAC5B,cAAc,qBAAqB,EAAE;IACrC,oBAAoB,aAAa,EAAE;IACnC,aAAa,mBAAmB,EAAE;AACtC;;AAEA;IACI,WAAW,yBAAyB,EAAE;IACtC,gBAAgB,aAAa,EAAE;IAC/B,eAAe,mBAAmB,EAAE;IACpC,sBAAsB,gBAAgB,EAAE;AAC5C","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n    color-scheme: dark;\n    --background: #212121;\n    --surface: #2f2f2f;\n    --surface-hover: #3a3a3a;\n    --sidebar: #171717;\n    --border: #3f3f3f;\n    --text: #ececec;\n    --muted: #a7a7a7;\n    --accent: #b89954;\n}\n\n* { box-sizing: border-box; }\n\nhtml, body, #root {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n}\n\nbody {\n    overflow: hidden;\n    background: var(--background);\n    color: var(--text);\n    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n}\n\nbutton, textarea { font: inherit; }\n\n.app {\n    display: flex;\n    width: 100%;\n    height: 100dvh;\n    background: var(--background);\n}\n\n.sidebar {\n    width: 270px;\n    flex: 0 0 270px;\n    display: flex;\n    flex-direction: column;\n    padding: 12px;\n    background: var(--sidebar);\n    border-right: 1px solid #242424;\n}\n\n.sidebar-top { display: flex; flex-direction: column; gap: 14px; }\n\n.logo-container {\n    display: flex;\n    align-items: center;\n    min-height: 58px;\n    padding: 8px 10px 14px;\n    border-bottom: 1px solid #2c2c2c;\n}\n\n.logo { width: 132px; height: auto; object-fit: contain; }\n\n.new-chat {\n    width: 100%;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 12px;\n    padding: 10px 12px;\n    margin: 0;\n    color: var(--text);\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 160ms ease, border-color 160ms ease;\n}\n\n.new-chat:hover { background: #242424; border-color: #303030; }\n.new-chat svg { width: 18px; height: 18px; }\n\n.sidebar-copy {\n    margin-top: 22px;\n    padding: 0 12px;\n    color: #858585;\n    font-size: 12px;\n    line-height: 1.5;\n}\n\n.sidebar-copy-label {\n    color: #b7b7b7;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: .08em;\n    text-transform: uppercase;\n}\n\n.sidebar-copy p { margin: 8px 0 0; }\n\n.user-card {\n    display: flex;\n    align-items: center;\n    gap: 11px;\n    min-width: 0;\n    margin-top: auto;\n    padding: 12px 8px 4px;\n    border-top: 1px solid #2c2c2c;\n}\n\n.user-avatar {\n    position: relative;\n    width: 38px;\n    height: 38px;\n    flex: 0 0 38px;\n    display: grid;\n    place-items: center;\n    overflow: visible;\n    border-radius: 50%;\n    background: #5d5035;\n    color: white;\n    font-weight: 600;\n}\n\n.user-avatar img { width: 100%; height: 100%; border-radius: inherit; object-fit: cover; }\n\n.status {\n    position: absolute;\n    right: -1px;\n    bottom: 0;\n    width: 10px;\n    height: 10px;\n    border: 2px solid var(--sidebar);\n    border-radius: 50%;\n    background: #777;\n}\n\n.status.Available, .status.AvailableIdle { background: #56a968; }\n.status.Busy, .status.DoNotDisturb { background: #d45c58; }\n.status.Away, .status.BeRightBack { background: #d69b46; }\n\n.user-info { min-width: 0; }\n.user-name { overflow: hidden; color: #ededed; font-size: 13px; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }\n.user-email { margin-top: 2px; overflow: hidden; color: #858585; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }\n\n.chat-container {\n    position: relative;\n    min-width: 0;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    height: 100dvh;\n    margin: 0;\n    background: var(--background);\n}\n\n.mobile-header { display: none; }\n\n.welcome {\n    width: min(760px, calc(100% - 40px));\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    padding: 32px 0 18px;\n    text-align: center;\n}\n\n.welcome-icon, .assistant-avatar {\n    display: grid;\n    place-items: center;\n    overflow: hidden;\n    border: 1px solid #4a4231;\n    border-radius: 50%;\n    background: #292620;\n}\n\n.welcome-icon { width: 54px; height: 54px; margin-bottom: 20px; }\n.welcome-icon img, .assistant-avatar img { width: 72%; height: 72%; object-fit: contain; }\n\n.welcome h1 {\n    margin: 0;\n    color: #f2f2f2;\n    font-size: clamp(25px, 3vw, 34px);\n    font-weight: 600;\n    letter-spacing: -.03em;\n}\n\n.welcome > p { max-width: 560px; margin: 12px 0 30px; color: var(--muted); font-size: 14px; line-height: 1.6; }\n\n.suggestions {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n}\n\n.suggestions button {\n    min-height: 116px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 16px;\n    margin: 0;\n    color: #d8d8d8;\n    background: transparent;\n    border: 1px solid var(--border);\n    border-radius: 14px;\n    text-align: left;\n    cursor: pointer;\n    transition: background 160ms ease, border-color 160ms ease;\n}\n\n.suggestions button:hover:not(:disabled) { background: #292929; border-color: #555; }\n.suggestions button:disabled { cursor: wait; opacity: .45; }\n.suggestions svg { width: 19px; height: 19px; color: var(--accent); }\n.suggestions span { font-size: 13px; line-height: 1.45; }\n\n.messages {\n    flex: 1;\n    overflow-y: auto;\n    scroll-behavior: smooth;\n}\n\n.messages-inner { width: min(820px, calc(100% - 40px)); margin: 0 auto; padding: 42px 0 28px; }\n\n.message-row {\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    margin-bottom: 28px;\n}\n\n.message-row.user { justify-content: flex-end; }\n.assistant-avatar { width: 30px; height: 30px; flex: 0 0 30px; margin-top: 3px; }\n.msg { min-width: 0; color: var(--text); font-size: 15px; line-height: 1.7; }\n.msg.bot { width: calc(100% - 44px); }\n.msg.user { width: fit-content; max-width: min(72%, 620px); }\n\n.message-bubble { overflow-wrap: anywhere; }\n.msg.user .message-bubble { padding: 10px 16px; background: var(--surface); border-radius: 20px; }\n.message-bubble p:first-child { margin-top: 0 !important; }\n.message-bubble p:last-child { margin-bottom: 0 !important; }\n.message-bubble ul, .message-bubble ol { margin: 10px 0; padding-left: 22px; }\n.message-bubble a { color: #7db4f4; text-decoration: underline; text-underline-offset: 2px; }\n\n.code-block {\n    max-width: 100%;\n    margin: 14px 0;\n    padding: 15px;\n    overflow-x: auto;\n    background: #141414;\n    border: 1px solid #353535;\n    border-radius: 10px;\n}\n\n.inline-code { padding: 2px 5px; color: #e5c981; background: #151515; border-radius: 4px; }\n\n.input-area {\n    flex: 0 0 auto;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 10px 24px 12px;\n    background: linear-gradient(180deg, rgba(33,33,33,0), var(--background) 24%);\n}\n\n.composer-wrap { width: min(820px, 100%); }\n\n.input-box {\n    width: 100%;\n    padding: 8px;\n    background: var(--surface);\n    border: 1px solid #494949;\n    border-radius: 24px;\n    box-shadow: 0 6px 28px rgba(0,0,0,.2);\n    transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.input-box:focus-within { border-color: #656565; box-shadow: 0 8px 32px rgba(0,0,0,.26); }\n.composer-row { display: flex; align-items: flex-end; gap: 6px; }\n\n.input-box textarea {\n    min-height: 36px;\n    max-height: 180px;\n    flex: 1;\n    padding: 7px 6px 5px;\n    overflow-y: auto !important;\n    resize: none;\n    outline: none;\n    color: var(--text);\n    background: transparent;\n    border: 0;\n    font-size: 15px;\n    line-height: 1.5;\n}\n\n.input-box textarea::placeholder { color: #9a9a9a; }\n\n.icon-button {\n    width: 36px;\n    height: 36px;\n    flex: 0 0 36px;\n    display: grid;\n    place-items: center;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.attach-button { color: #cacaca; background: transparent; }\n.attach-button:hover:not(:disabled) { background: #414141; }\n.send-button { color: #202020; background: #f1f1f1; }\n.send-button:hover:not(:disabled) { background: white; }\n.icon-button:disabled { cursor: default; opacity: .32; }\n.icon-button svg { width: 18px; height: 18px; }\n\n.attachment-preview { position: relative; width: fit-content; margin: 2px 4px 8px; }\n.attachment-preview > img { width: 84px; height: 68px; display: block; object-fit: cover; border-radius: 10px; }\n.attachment-file { max-width: 230px; display: flex; align-items: center; gap: 8px; padding: 10px 12px; color: #ddd; background: #232323; border-radius: 10px; font-size: 12px; }\n.attachment-file span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.remove-attachment { position: absolute; top: -7px; right: -7px; width: 22px; height: 22px; display: grid; place-items: center; padding: 0; margin: 0; color: #eee; background: #444; border: 2px solid var(--surface); border-radius: 50%; cursor: pointer; }\n\n.input-disclaimer { margin: 7px 0 0; color: #8b8b8b; font-size: 11px; text-align: center; }\n.connection-error { width: min(820px, calc(100% - 48px)); margin: 0 auto 2px; padding: 9px 12px; color: #ffc8c5; background: #4a2828; border-radius: 9px; font-size: 12px; text-align: center; }\n\n.button-spinner { width: 15px; height: 15px; border: 2px solid #777; border-top-color: #222; border-radius: 50%; animation: spin .7s linear infinite; }\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.messages::-webkit-scrollbar, .input-box textarea::-webkit-scrollbar { width: 7px; }\n.messages::-webkit-scrollbar-thumb, .input-box textarea::-webkit-scrollbar-thumb { background: #4b4b4b; border-radius: 10px; }\n\n@media (max-width: 760px) {\n    .sidebar { display: none; }\n    .mobile-header {\n        min-height: 52px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 14px;\n        margin: 0;\n        border-bottom: 1px solid #303030;\n        font-size: 14px;\n    }\n    .mobile-header button { width: 36px; height: 36px; display: grid; place-items: center; padding: 0; color: var(--text); background: transparent; border: 0; border-radius: 8px; }\n    .welcome { width: calc(100% - 28px); padding-top: 20px; }\n    .welcome-icon { width: 46px; height: 46px; margin-bottom: 15px; }\n    .welcome > p { margin-bottom: 22px; }\n    .suggestions { grid-template-columns: 1fr; gap: 8px; }\n    .suggestions button { min-height: auto; flex-direction: row; align-items: center; justify-content: flex-start; gap: 12px; padding: 13px 14px; }\n    .messages-inner { width: calc(100% - 28px); padding-top: 24px; }\n    .message-row { gap: 10px; margin-bottom: 22px; }\n    .msg.user { max-width: 85%; }\n    .input-area { padding: 8px 10px 9px; }\n    .input-disclaimer { display: none; }\n    .input-box { border-radius: 20px; }\n}\n\n@media (max-height: 700px) and (min-width: 761px) {\n    .welcome { justify-content: flex-end; }\n    .welcome-icon { display: none; }\n    .welcome > p { margin-bottom: 18px; }\n    .suggestions button { min-height: 94px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
